import { render } from "./bookDetails.vue?vue&type=template&id=121ea791"
import script from "./bookDetails.vue?vue&type=script&lang=js"
export * from "./bookDetails.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__